<template>
  <div>
    <div
      v-if="texts"
      :class="`fixed w-screen h-screen top-0 left-0 z-40 justify-center items-center ${
        backgroundBlack ? 'flex' : 'hidden'
      }`"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div
        v-if="texts[actualText].position === 'center'"
        class="center-screen bg-white w-full sm:w-1/3 border-b-4 border-amber-400 rounded-md flex justify-between items-center p-4 lg:px-10 md:space-x-8 flex-col md:flex-row space-y-4"
      >
        <img
          class="sm:w-max w-1/2"
          src="@/assets/images/avatar.png"
          style="min-width: 100px"
          alt="avatar"
        />
        <div class="space-y-4 sm:w-2/3 w-full">
          <h6 class="text-xl font-bold">
            {{ texts[actualText].title }}
          </h6>
          <p class="text-md">
            {{ texts[actualText].text }}
          </p>
          <div class="flex flex-row">
            <button
              class="btn-simple flex flex-row space-x-2 items-center w-48"
            >
              <i
                :class="audioON ? 'pi pi-volume-up' : 'pi pi-volume-off'"
                style="font-size: 1rem"
              ></i>
              <p>{{ audioON ? "Áudio ligado" : "Áudio desligado" }}</p>
            </button>
            <Button
              class="btn-simple p-0 p-button-sm text-sm"
              icon="pi pi-replay"
              label="Repetir"
            ></Button>
          </div>
          <div>
            <Button class="btn-primary w-full" @click="nextText()">{{
              texts[actualText].answers[0].text
            }}</Button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="texts[actualText].position === 'right'"
      class="right-screen bg-h-primary-100 border-b-4 border-r-4 fixed bottom-28 right-4 z-20 md:right-16 border-amber-400 rounded-t-2xl rounded-bl-2xl flex md:justify-between p-4 py-8 md:p-4 md:py-10 md:pr-10 flex-col sm:flex-row md:space-x-8"
    >
      <div
        class="mb-4 w-full sm:w-1/3 flex items-center justify-center sm:items-start"
      >
        <img
          class="sm:w-max w-1/2"
          src="@/assets/images/avatar.png"
          alt="avatar"
        />
      </div>
      <div class="space-y-4 sm:w-2/3 w-full">
        <h6 class="text-xl font-bold">
          {{ texts[actualText].title }}
        </h6>
        <p class="text-md">
          {{ texts[actualText].text }}
        </p>
        <div class="flex flex-row">
          <MessageVoice
            :msg="texts[actualText].title + '.' + texts[actualText].text"
          />
        </div>
        <div>
          <Button class="btn-primary w-full" @click="nextText()">{{
            texts[actualText].answers[0].text
          }}</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ChatBotService } from "../chat-bot.service";
export default defineComponent({
  name: "alert-homero",
  computed: {
    chatbotService(): ChatBotService {
      return new ChatBotService();
    },
    audioON(): boolean {
      return window.speechSynthesis.speaking;
    },
  },
  props: {
    texts: {
      type: [] as any,
    },
    backgroundBlack: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      audioON: false as boolean,
      actualText: 0,
    };
  },
  methods: {
    // playAudio(text: string): void {
    //   const result: SpeechSynthesisUtterance =
    //     this.chatbotService.textToSpeech(text);
    //   result.onstart = () => {
    //     this.audioON = true;
    //   };

    //   result.onend = () => {
    //     this.audioON = false;
    //   };
    // },
    // stopAudio(text: string): void {
    //   this.chatbotService.stopTextToSpeech(text);
    // },
    nextText(): void {
      if (this.actualText < this.texts.length - 1) {
        this.actualText = this.actualText + 1;
        this.audioON = false;
      } else {
        this.$emit("closeAlert", false);
      }
    },
  },
});
</script>
<style scoped>
.btn-tutorial {
  width: 9.5%;
  min-width: 140px;
  opacity: 0.5;
}
.center-screen {
  width: 40%;
  min-height: 350px;
  min-width: 600px;
}
.right-screen {
  width: 38%;
  min-height: 300px;
  min-width: 600px;
}
@media screen and (max-width: 650px) {
  .center-screen {
    width: 90%;
    min-width: 350px;
  }
  .right-screen {
    min-width: 350px;
  }
}
</style>
